import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './BtnWhatsapp.css';
import whatsappIcon from '../../images/wpp.png';
import Modal from 'react-modal';
import baseURL from '../url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

export default function BtnWhatsapp() {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [tienda, setTienda] = useState([]);
    const [selectedContact, setSelectedContact] = useState(null);
    const [noteText, setNoteText] = useState('¡Hola! Estoy interesado en..');
    const textRef = useRef(null);
    const [sending, setSending] = useState(false);
    const routerLocation = useLocation();
    useEffect(() => { try { Modal.setAppElement('#root'); } catch(_){} }, []);


    useEffect(() => {
        cargarTienda()
    }, []);
    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTienda(data.tienda.reverse() || []);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    const openModal = () => {
        if (window.__wppOpen) return;
        window.__wppOpen = true;
        setModalIsOpen(true);
        try{ window.dispatchEvent(new Event('open-whatsapp')); }catch(_){ }
    };

    const closeModal = () => {
        setModalIsOpen(false);
        window.__wppOpen = false;
    };

    useEffect(() => {
        const onCloseAll = () => { setModalIsOpen(false); window.__wppOpen = false; };
        const onOpenWpp = () => {
            if (window.__wppOpen) return;
            window.__wppOpen = true;
            setModalIsOpen(true);
        };
        window.addEventListener('close-all-overlays', onCloseAll);
        window.addEventListener('open-whatsapp', onOpenWpp);
        return () => { window.removeEventListener('close-all-overlays', onCloseAll); window.removeEventListener('open-whatsapp', onOpenWpp); };
    }, []);

    useEffect(() => {
        setModalIsOpen(false);
    }, [routerLocation.pathname, routerLocation.search]);

    const handleWhatsappMessage = () => {
        if (selectedContact || tienda?.length <= 1) {
            const raw = tienda?.length <= 1 ? tienda[0]?.telefono : selectedContact?.telefono;
            const d = String(raw||'').replace(/\D+/g,'');
            const p = d;
            const message = noteText.trim() ? `\n ${noteText}` : '';
            const whatsappUrl = `https://api.whatsapp.com/send?phone=${p}&text=${encodeURIComponent(message)}`;
            setSending(true);
            setTimeout(()=> setSending(false), 700);
            window.open(whatsappUrl, '_blank');
            setNoteText('');
            closeModal();
        }
    };

    return (
        <div className='containWpp'>
            <button className='btnWhatsapp' onClick={openModal}>
                <img src={whatsappIcon} alt="whatsappIcon" />
            </button>

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                className="modal-wpp"
                overlayClassName="overlay-wpp"
            >
                <div className='containModalWpp'>


                    <div className='headerWpp'>

                        {tienda.length > 1 ? (
                            <span>
                                Selecciona un teléfono
                            </span>
                        ) : (
                            <span>
                                Envíanos un mensaje
                            </span>
                        )}
                        <button onClick={closeModal} className='closeBtn'>
                            X
                        </button>
                    </div>
                    <div className='mensaje'>
                        <p>Hola, ¿en qué podemos ayudarte? 👋</p>
                    </div>

                    <div className='btnsWpp'>
                        {tienda.length > 1 && (
                            <div className='btnsWpp'>
                                {tienda.map(item => (
                                    <button
                                        key={item.idContacto}
                                        className='btnWpp'
                                        style={{ backgroundColor: selectedContact && selectedContact.idContacto === item.idContacto ? 'green' : '' }}
                                        onClick={() => setSelectedContact(item)}
                                    >
                                        {item.telefono}
                                        <img src={whatsappIcon} alt="whatsappIcon" />
                                    </button>
                                ))}
                            </div>
                        )}


                    </div>
                    <div className='sendWpp'>
                        <textarea
                            placeholder="Envíanos un mensaje"
                            value={noteText}
                            onChange={(e) => { setNoteText(e.target.value); try{ const el = textRef.current; if(el){ el.style.height = 'auto'; const max = Math.min(el.scrollHeight, Math.floor(window.innerHeight*0.24)); el.style.height = `${Math.max(42, max)}px`; } }catch(_){ } }}
                            ref={textRef}
                            rows={2}
                        />
                        <button onClick={handleWhatsappMessage} className={sending?'sending':''}>
                            <FontAwesomeIcon icon={faPaperPlane} />
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    );
}
